import React from "react";
import { Typography, Tooltip } from "antd";
import { Common, Fulfillment } from "@secondcloset/types";
import { startCase } from "lodash-es";

export const returnConfigLabel = {
  item_good_package_open: { title: "Opened, but item in good condition", position: 1 },
  item_damaged: { title: "Item damaged", position: 2 },
  item_good_package_damaged: { title: "Packaging damaged, item in good condition", position: 3 },
  email_customer: { title: "Allow GoBolt to email customers", position: 4 },
  preferred_return_facility: { title: "Preferred Return Facility", position: 5 },
} as Record<string, { title: string; position: number }>;

export type Address = Fulfillment.ReturnsConfiguration["address"] & Common.Facility<"V2">["address"];

export const parseAddress = (address?: Address) => {
  const { address: line_1, street, city, province, postal_code, country } = address ?? {};
  const addressString = [line_1, street, city, province, postal_code, country].filter(Boolean).join(", ");
  return <Tooltip title={addressString}>{addressString || "-"}</Tooltip>;
};

const renderStartCase = (value?: string) => (value ? startCase(value) : "-");

export const COLUMNS = [
  {
    title: "Options",
    dataIndex: "condition",
    key: "condition",
    render: renderStartCase,
  },
  {
    title: "Instruction",
    dataIndex: "instruction",
    key: "instruction",
    render: renderStartCase,
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",

    render: parseAddress,
  },
  {
    title: "Comment",
    dataIndex: "comment",
    key: "comment",
    render: (comment?: string) => {
      if (!comment) return "-";
      return (
        <Tooltip title={comment}>
          <Typography.Link>View</Typography.Link>
        </Tooltip>
      );
    },
  },
];
